module.exports = __webpack_public_path__ + "img/CATEGORY ICON-05.742ef3c8.png";